export const ABOUT_HIGHLIGHTS_UPLOAD_REQUEST = "ABOUT_HIGHLIGHTS_UPLOAD_REQUEST";
export const ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS = "ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS";
export const ABOUT_HIGHLIGHTS_UPLOAD_FAIL = "ABOUT_HIGHLIGHTS_UPLOAD_FAIL";

export const ABOUT_HIGHLIGHTS_FETCH_REQUEST = "ABOUT_HIGHLIGHTS_FETCH_REQUEST";
export const ABOUT_HIGHLIGHTS_FETCH_SUCCESS = "ABOUT_HIGHLIGHTS_FETCH_SUCCESS";
export const ABOUT_HIGHLIGHTS_FETCH_FAIL = "ABOUT_HIGHLIGHTS_FETCH_FAIL";

export const ABOUT_HIGHLIGHTS_DELETE_REQUEST = "ABOUT_HIGHLIGHTS_DELETE_REQUEST";
export const ABOUT_HIGHLIGHTS_DELETE_SUCCESS = "ABOUT_HIGHLIGHTS_DELETE_SUCCESS";
export const ABOUT_HIGHLIGHTS_DELETE_FAIL = "ABOUT_HIGHLIGHTS_DELETE_FAIL";